import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import ChevronLeftIcon from "../../../assets/svg/ChevronLeftIcon";
import { applicantList, getJobById } from "../../../endpoints/job.service";
import Spinner from "../../../components/Spinner/Spinner";
import { useDispatch } from "react-redux";
import { setJobDetail } from "../../../store/actions/job.action";

const tabs = [
  { name: "Job Post", path: "job-post" },
  { name: "Applicants", path: "applicants" },
  { name: "Shortlisted", path: "shortlisted" },
];

const JobDetail = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { jobId } = useParams();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchJobDetails();
    }
  }, []);

  const fetchJobDetails = async () => {
    try {
      const jobResponse = await getJobById({jobId});
      const { data: jobData, success: jobSuccess } = jobResponse;
      if (jobSuccess) {
        const applicantResponse = await applicantList(jobId);
        const { data: applicantData, success: applicantSuccess } =
          applicantResponse;
        if (applicantSuccess) {
          dispatch(setJobDetail({ ...jobData, applicantData }));
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow p-4">
      <button
        onClick={() => navigate("/job")}
        className="flex items-center self-start"
      >
        <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
        <label className="text-xs font-medium text-primary cursor-pointer">
          Back to listing
        </label>
      </button>

      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="flex items-center gap-24 border-b px-3 mt-8 pb-2">
            {tabs?.map((item, index) => {
              const isActive = pathname?.includes(item?.path);
              return (
                <button
                  onClick={() => navigate(item?.path)}
                  key={index}
                  className={`flex items-center ${
                    isActive ? "border-b border-primary" : ""
                  }`}
                >
                  <span
                    className={`text-xs pb-0.5 ${
                      isActive ? "text-primary font-medium" : "text-gray-500"
                    }`}
                  >
                    {item?.name}
                  </span>
                </button>
              );
            })}
          </div>
          <div className="flex flex-1 flex-col overflow-y-hidden no-scrollbar">
            <Outlet />
          </div>
        </>
      )}
    </div>
  );
};

export default JobDetail;
